import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMAgentValidation } from "../graphql/mutations";
import {
  UpdateLLMAgentValidationInput,
  UpdateLLMAgentValidationMutation,
} from "../API";

export async function updateValidationAfterEdit(
  values: UpdateLLMAgentValidationInput
): Promise<GraphQLResult<UpdateLLMAgentValidationMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMAgentValidation, {
      input: {
        id: values.id,
        name: values.name,
        description: values.description,
        operator: values.operator,
        expectedValue: values.expectedValue,
        customPromptTemplate: values.customPromptTemplate,
        status: values.status,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMAgentValidationMutation>>;
}
